/** FAQs accordion */
export const faqs = () => {
  const questions = document.querySelectorAll('.question');

  if (!questions.length) return;

  // Add click event listener to each question
  questions.forEach((question) => {
    // Initial ARIA attributes setup
    question.setAttribute('aria-expanded', 'false');
    question.nextElementSibling.setAttribute('aria-hidden', 'true');

    // on click, toggle answer and active class
    question.addEventListener('click', () => {
      toggleAnswerAndActiveClass(question);
    });
  });
};

function toggleAnswerAndActiveClass(question) {
  // Toggle the 'active' class on the parent 'section'
  question.classList.toggle('active');

  // Toggle visibility of the next sibling (the answer)
  const answer = question.nextElementSibling;
  const isExpanded = answer.style.display === 'block';
  answer.style.display = isExpanded ? 'none' : 'block';

  // Set ARIA attributes
  question.setAttribute('aria-expanded', !isExpanded);
  answer.setAttribute('aria-hidden', isExpanded);
}
